import React from 'react'
import { Link } from 'react-router-dom'
import { siteConfig } from '../../settings'
import { FaHome } from 'react-icons/fa'

// image
import logo from '../../resource/image/logo.jpg'

export default ({ collapsed }) => {
    return (
        <div className="isoLogoWrapper">
            {collapsed ? (
                <div>
                    <h3>
                        <Link to="/dashboard">
                            <FaHome className={siteConfig.siteIcon} />
                        </Link>
                    </h3>
                </div>
            ) : (
                <h3>
                    <Link to="/dashboard">
                        <div>
                            <img className="Image" src={logo} alt="logo" />{' '}
                        </div>
                        {/* {siteConfig.siteName} */}
                    </Link>
                </h3>
            )}
        </div>
    )
}
